"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = exports.USER_PERSON_TYPE = exports.USER_TYPE = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const helpers_1 = require("@tpd-web-common-libs/nodejs-library/dist/src/helpers");
const common_1 = require("../common");
const user_info_model_1 = require("./user-info.model");
var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["PROSPECT"] = "prospect";
    USER_TYPE["CLIENTE"] = "cliente";
    USER_TYPE["FULL_PROSPECT"] = "full prospect";
    USER_TYPE["UNIDENTIFIED"] = "tipo cliente non identificato";
})(USER_TYPE = exports.USER_TYPE || (exports.USER_TYPE = {}));
var USER_PERSON_TYPE;
(function (USER_PERSON_TYPE) {
    USER_PERSON_TYPE["PERSONA_GIURIDICA"] = "Persona Giuridica";
    USER_PERSON_TYPE["PERSONA_FISICA"] = "Persona Fisica";
    USER_PERSON_TYPE["PERSONA_FISICA_O_GIURIDICA"] = "Persona Fisica o Giuridica";
})(USER_PERSON_TYPE = exports.USER_PERSON_TYPE || (exports.USER_PERSON_TYPE = {}));
class UserService {
    getInfoUtente(infootp = true, infoprospect = true, posticipaPrivacy = false) {
        return __awaiter(this, void 0, void 0, function* () {
            helpers_1.ConsoleHelper.log("[Request] infoUtente");
            const commonNetworkService = new nodejs_library_1.CommonNetworkService();
            let response = {};
            try {
                response = yield commonNetworkService.get("/api/priv/contesto-utente/v1/me/infoUtente", {
                    infootp,
                    infoprospect,
                    posticipaPrivacy,
                }, false);
            }
            catch (e) {
                helpers_1.ConsoleHelper.error("Errore durante il recupero delle informazioni dell'utente", e);
            }
            helpers_1.ConsoleHelper.log("<Response> infoUtente: ", response);
            return response;
        });
    }
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            helpers_1.ConsoleHelper.log("[Request] getAccount");
            const commonNetworkService = new nodejs_library_1.CommonNetworkService();
            const completeUrl = "/api/priv/contesto-utente/v1/me/account";
            const response = yield commonNetworkService.get(completeUrl);
            helpers_1.ConsoleHelper.log("<Response> getAccount: ", response);
            return Object.keys(response).length > 0 ? response : {};
        });
    }
    getUserType(classification) {
        switch (classification) {
            case "0":
                return USER_TYPE.FULL_PROSPECT;
            case "1":
                return USER_TYPE.PROSPECT;
            case "2":
                return USER_TYPE.CLIENTE;
            default:
                return USER_TYPE.UNIDENTIFIED;
        }
    }
    getAnagrafica() {
        return __awaiter(this, void 0, void 0, function* () {
            let response = undefined;
            let isSuperUser = false;
            try {
                const localData5Storage = yield nodejs_library_1.Helpers.SessionHelper.getData(common_1.Constants.lsMapObject._data5);
                if (localData5Storage) {
                    const jsonObject = JSON.parse(localData5Storage);
                    isSuperUser = jsonObject.value0 === "0";
                }
            }
            catch (e) {
                helpers_1.ConsoleHelper.error("Errore durante il recupero dei dati da SU", e);
                throw e;
            }
            const su = isSuperUser ? "su/" : "";
            const commonNetworkService = new nodejs_library_1.CommonNetworkService();
            try {
                const datiAnagrafici = yield commonNetworkService.get(`/api/priv/contesto-utente/v1/me/${su}cliente/anagrafica`);
                if (datiAnagrafici) {
                    const recapiti = yield this._basicGetFunction("/api/priv/contesto-utente", "/v1", '/me/$SU/recapiti', su);
                    const utente = yield this._basicGetFunction("/api/priv/contesto-utente", "/v1", '/me/$SU/utente', su);
                    const cliente = yield this._basicGetFunction("/api/priv/contesto-utente", "/v1", '/me/$SU/cliente', su);
                    const polizzeCRM = yield this._basicGetFunction("/api/priv/contesto-utente", "/v2", '/me/$SU/polizze', su);
                    const polizzeCollettive = yield this._basicGetFunction('/api/priv/polizze-collettive', '/v1', '/polizze', su);
                    const polizzePrevidenza = yield this._getPolizzePrevidenza(su);
                    const polizze = { polizze: [
                            ...((polizzeCRM === null || polizzeCRM === void 0 ? void 0 : polizzeCRM.polizze) || []),
                            ...((polizzeCollettive === null || polizzeCollettive === void 0 ? void 0 : polizzeCollettive.polizze) || []),
                            ...((polizzePrevidenza === null || polizzePrevidenza === void 0 ? void 0 : polizzePrevidenza.polizze) || [])
                        ] };
                    const contattiTelematici = yield this._basicGetFunction('/api/priv/contesto-utente', '/v2', '/me/$SU/contrattiTelematici', su);
                    response = new user_info_model_1.UserInfoModel(this._buildUserInfo(datiAnagrafici, recapiti, utente, cliente, polizze, contattiTelematici));
                }
                else
                    throw null;
            }
            catch (e) {
                helpers_1.ConsoleHelper.error("Errore durante il recupero dell'anagrafica", e);
                throw e;
            }
            return response;
        });
    }
    _basicGetFunction(baseUrl, version, endPoint, su) {
        return __awaiter(this, void 0, void 0, function* () {
            const commonNetworkService = new nodejs_library_1.CommonNetworkService();
            let response = undefined;
            try {
                const replacedEndPoint = endPoint.replace('$SU/', su);
                response = yield commonNetworkService.get(`${baseUrl}${version}${replacedEndPoint}`);
            }
            catch (e) {
                const data = yield e;
                helpers_1.ConsoleHelper.error("Errore durante il recupero dei dati", data);
            }
            return response;
        });
    }
    _getPolizzePrevidenza(su) {
        return __awaiter(this, void 0, void 0, function* () {
            const esito = { polizze: [] };
            const polizzePrevidenza = yield this._basicGetFunction('/api/priv/polizze-previdenza', '/v1', '/previdenza/polizze', su);
            let ivassAttivo = false;
            try {
                ivassAttivo = yield nodejs_library_1.Helpers.SessionHelper.getData("IVASS");
            }
            catch (e) {
                helpers_1.ConsoleHelper.error("Errore recupero stato IVASS", e);
            }
            if (polizzePrevidenza) {
                esito.polizze = polizzePrevidenza.polizze.filter((polizza) => !ivassAttivo || (ivassAttivo && (polizza.ruoloContraente === "ContraenteFPP" || polizza.ruoloContraente === "ContraenteRIM")));
            }
            return esito;
        });
    }
    _buildUserInfo(data1, data2, data3, data4, data5, data6) {
        var _a, _b, _c, _d, _e, _f;
        let recapitiUtente = undefined;
        let utente = undefined;
        let cliente = undefined;
        let polizze = undefined;
        let telematici = undefined;
        const anagraficaUtente = (typeof data1 === "string" && JSON.parse(data1)) || data1;
        if (data2)
            recapitiUtente = (typeof data2 === "string" && JSON.parse(data2)) || data2;
        if (data3)
            utente = (typeof data3 === "string" && JSON.parse(data3)) || data3;
        if (data4)
            cliente = (typeof data4 === "string" && JSON.parse(data4)) || data4;
        if (data5)
            polizze = (typeof data5 === "string" && JSON.parse(data5)) || data5;
        if (data6)
            telematici = (typeof data6 === "string" && JSON.parse(data6)) || data6;
        let usernameUI = "";
        let partyIdUI = undefined;
        if (utente) {
            usernameUI = utente.username;
            partyIdUI = utente.partyId;
        }
        const addressesArray = (_a = anagraficaUtente === null || anagraficaUtente === void 0 ? void 0 : anagraficaUtente.indirizzi) === null || _a === void 0 ? void 0 : _a.map(item => ({
            state: item.stato,
            province: item.provincia,
            cap: item.cap,
            district: item.comune,
            locality: item.localita,
            address: item.indirizzo,
            agencyDescription: item.descAgenzia,
            agencyKey: item.chiaveAgenzia,
            addressType: item.tipoIndirizzo,
            addressId: item.indirizzoId
        }));
        let contactInformationsArray;
        if (recapitiUtente === null || recapitiUtente === void 0 ? void 0 : recapitiUtente.recapiti) {
            contactInformationsArray = recapitiUtente === null || recapitiUtente === void 0 ? void 0 : recapitiUtente.recapiti.map(item => {
                var _a, _b, _c, _d, _e;
                return ({
                    function: ((_a = item.origine) === null || _a === void 0 ? void 0 : _a.id) ? (_c = (_b = item.origine) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.toString() : (_d = item.origine) === null || _d === void 0 ? void 0 : _d.id,
                    type: item.tipo ? (_e = item.tipo) === null || _e === void 0 ? void 0 : _e.toString() : item.tipo,
                    value: item.valore,
                    certified: item.certificato,
                });
            }).filter(item => (item === null || item === void 0 ? void 0 : item.function) === "1");
        }
        const removeDuplicates = (array, property) => {
            return array.filter((obj, pos, arr) => arr.map((mapObj) => mapObj[property]).indexOf(obj[property]) === pos);
        };
        const registryUI = {
            optOutSms: anagraficaUtente.optOutSms,
            optOutEmail: anagraficaUtente.optOutEmail,
            contactInformations: contactInformationsArray ? removeDuplicates(contactInformationsArray, "type") : [],
            addresses: addressesArray,
            agreedCustomer: anagraficaUtente.clienteConvenzionato,
            bankCustomer: anagraficaUtente.clienteBanca,
            commercialPrivacy: anagraficaUtente.privacyCommerciale,
            birthDate: anagraficaUtente.nascitaDt,
            birthLocation: anagraficaUtente.nascitaLuogo,
            gender: anagraficaUtente.sesso,
            taxCodeVAT: anagraficaUtente.cfPiva,
            companyName: anagraficaUtente.ragioneSociale,
            name: anagraficaUtente.nome,
            surname: anagraficaUtente.cognome,
            type: anagraficaUtente.tipo,
            feaAuthorizationFlag: anagraficaUtente.flagAutorizzazioneFea,
            contactInformationsAgencies: [],
        };
        let customerUI;
        if (cliente) {
            customerUI = {
                preactivationDate: cliente.dataPreattivazione,
                name: cliente.nominativo,
                taxCode: utente ? utente.codiceFiscale : "",
                customerPartyId: cliente.partyIdCliente,
                updatedPrivacy: cliente.flagAggiornamentoPrivacy,
                submitTokenCount: cliente.contaInvioToken,
                customerId: cliente.customerId,
            };
        }
        let policiesUI;
        if (polizze === null || polizze === void 0 ? void 0 : polizze.polizze) {
            policiesUI = (_b = polizze.polizze) === null || _b === void 0 ? void 0 : _b.map((item) => {
                if (item.ruoloContraente == "1009" && item.comparto == 1002) {
                    item.sistemaContratto = "CDH_RE";
                }
                const policy = Object.assign({ familyId: item.famigliaId, expirationDate: item.dataScadenza, numberPlate: item.targaVeicolo, inArrears: item.flagArretrato, description: item.sistemaContratto === "CDH" ? `${item.descrizione} - Collettiva` : item.descrizione, policy: item.polizza, branch: item.ramo, agency: item.agenzia, exdivision: item.exdivisione, company: item.compagnia, division: item.comparto, agreementKey: item.chiaveContratto, agreementSystem: item.sistemaContratto, contractorRole: item.ruoloContraente, segmentValue: item.valoreSegmento, issueDate: item.dataEmissione, subFamilyId: item.sottoFamigliaId, premiumValidityDate: item.dataValiditaPremio ? item.dataValiditaPremio : null, rcaValidityDate: item.dataValiditaRca ? item.dataValiditaRca : null, cvtValidityDate: item.dataValiditaCvt ? item.dataValiditaCvt : null, premioTotaleAnnuoRinnovo: item.premioTotaleAnnuoRinnovo, metodoPagamentoAssociatoAttivo: item.metodoPagamentoAssociatoAttivo, metodoPagamentoAssociatoPresente: item.metodoPagamentoAssociatoPresente }, item);
                return policy;
            });
        }
        let telematicsUI;
        if (telematici) {
            const contrattiAuto = (_d = (_c = telematici.auto) === null || _c === void 0 ? void 0 : _c.contrattiAuto) === null || _d === void 0 ? void 0 : _d.map(item => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                return ({
                    telematicIdentifier: item.identificativoTelematico,
                    contractType: item.tipoContratto,
                    contractStatus: item.statoContratto,
                    startDate: item.dataInizio,
                    endDate: item.dataFine,
                    telematicDeviceId: item.idTelematicoDispositivo,
                    contactUsers: item.contattiUtenti.map((item) => {
                        const contatto = {
                            contactName: item.nomeContatto,
                            contactPhone: item.telefonoContatto,
                            contactEMail: item.emailContatto,
                        };
                        return contatto;
                    }),
                    vehicle: {
                        type: (_a = item.veicolo) === null || _a === void 0 ? void 0 : _a.tipo,
                        brand: (_b = item.veicolo) === null || _b === void 0 ? void 0 : _b.marca,
                        model: (_c = item.veicolo) === null || _c === void 0 ? void 0 : _c.modello,
                        plate: (_d = item.veicolo) === null || _d === void 0 ? void 0 : _d.targa,
                    },
                    terminalStatus: item.statoTerminale,
                    telematicDevice: {
                        deviceId: (_e = item.dispositivoTelematico) === null || _e === void 0 ? void 0 : _e.idDispositivo,
                        deviceType: (_f = item.dispositivoTelematico) === null || _f === void 0 ? void 0 : _f.tipoDispositivo,
                        deviceOwner: (_g = item.dispositivoTelematico) === null || _g === void 0 ? void 0 : _g.proprietarioDispositivo,
                        imei: (_h = item.dispositivoTelematico) === null || _h === void 0 ? void 0 : _h.imei,
                        deliveryTrackingAvailable: (_j = item.dispositivoTelematico) === null || _j === void 0 ? void 0 : _j.tracciabilitaConsegnaDisponibile,
                    },
                    insuranceContractType: item.tipoContrattoAssicurativo,
                    deleteDataOnContractExpiration: item.datiCancellatiAllaScadenzaDelContratto,
                    contractOwner: item.proprietarioContratto,
                    archiveNumber: item.numeroArchivio ? item.numeroArchivio : 0,
                });
            });
            const contrattiImmobili = (_f = (_e = telematici.immobili) === null || _e === void 0 ? void 0 : _e.contrattiImmobili) === null || _f === void 0 ? void 0 : _f.map(item => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30;
                return ({
                    companyId: item.idCompagnia,
                    installerRequested: item.installerRichiesto,
                    insuranceContractType: item.tipoContrattoAssicurativo,
                    insuranceContractId: item.idContrattoAssicurativo,
                    telematicIdentifier: item.identificativoTelematico,
                    archiveNumber: item.numeroArchivio ? item.numeroArchivio : "",
                    deviceType: item.tipoDispositivo,
                    buildingProperty: {
                        installationAddress: {
                            floor: (_b = (_a = item.proprietaImmobile) === null || _a === void 0 ? void 0 : _a.indirizzoInstallazione) === null || _b === void 0 ? void 0 : _b.piano,
                            stair: (_d = (_c = item.proprietaImmobile) === null || _c === void 0 ? void 0 : _c.indirizzoInstallazione) === null || _d === void 0 ? void 0 : _d.scala,
                            intern: (_f = (_e = item.proprietaImmobile) === null || _e === void 0 ? void 0 : _e.indirizzoInstallazione) === null || _f === void 0 ? void 0 : _f.interno,
                            extendedAddress: (_h = (_g = item.proprietaImmobile) === null || _g === void 0 ? void 0 : _g.indirizzoInstallazione) === null || _h === void 0 ? void 0 : _h.indirizzoEsteso,
                            postalCode: (_j = item.proprietaImmobile) === null || _j === void 0 ? void 0 : _j.indirizzoInstallazione.codicePostale,
                            town: (_l = (_k = item.proprietaImmobile) === null || _k === void 0 ? void 0 : _k.indirizzoInstallazione) === null || _l === void 0 ? void 0 : _l.citta,
                            province: (_o = (_m = item.proprietaImmobile) === null || _m === void 0 ? void 0 : _m.indirizzoInstallazione) === null || _o === void 0 ? void 0 : _o.provincia,
                            country: (_q = (_p = item.proprietaImmobile) === null || _p === void 0 ? void 0 : _p.indirizzoInstallazione) === null || _q === void 0 ? void 0 : _q.paese,
                        },
                        buildingAddress: {
                            extendedAddress: (_s = (_r = item.proprietaImmobile) === null || _r === void 0 ? void 0 : _r.indirizzoImmobile) === null || _s === void 0 ? void 0 : _s.indirizzoEsteso,
                            postalCode: (_u = (_t = item.proprietaImmobile) === null || _t === void 0 ? void 0 : _t.indirizzoImmobile) === null || _u === void 0 ? void 0 : _u.codicePostale,
                            town: (_w = (_v = item.proprietaImmobile) === null || _v === void 0 ? void 0 : _v.indirizzoImmobile) === null || _w === void 0 ? void 0 : _w.citta,
                            province: (_y = (_x = item.proprietaImmobile) === null || _x === void 0 ? void 0 : _x.indirizzoImmobile) === null || _y === void 0 ? void 0 : _y.provincia,
                            country: (_0 = (_z = item.proprietaImmobile) === null || _z === void 0 ? void 0 : _z.indirizzoImmobile) === null || _0 === void 0 ? void 0 : _0.paese,
                        },
                    },
                    contractor: {
                        company: (_1 = item.contraente) === null || _1 === void 0 ? void 0 : _1.compagnia,
                        surname: (_2 = item.contraente) === null || _2 === void 0 ? void 0 : _2.cognome,
                        name: (_3 = item.contraente) === null || _3 === void 0 ? void 0 : _3.nome,
                        identityId: (_4 = item.contraente) === null || _4 === void 0 ? void 0 : _4.idIdentita,
                        address: {
                            extendedAddress: (_6 = (_5 = item.contraente) === null || _5 === void 0 ? void 0 : _5.indirizzo) === null || _6 === void 0 ? void 0 : _6.indirizzoEsteso,
                            postalCode: (_8 = (_7 = item.contraente) === null || _7 === void 0 ? void 0 : _7.indirizzo) === null || _8 === void 0 ? void 0 : _8.codicePostale,
                            town: (_10 = (_9 = item.contraente) === null || _9 === void 0 ? void 0 : _9.indirizzo) === null || _10 === void 0 ? void 0 : _10.citta,
                            province: (_12 = (_11 = item.contraente) === null || _11 === void 0 ? void 0 : _11.indirizzo) === null || _12 === void 0 ? void 0 : _12.provincia,
                            country: (_14 = (_13 = item.contraente) === null || _13 === void 0 ? void 0 : _13.indirizzo) === null || _14 === void 0 ? void 0 : _14.paese,
                        },
                    },
                    deliverAddress: {
                        careOf: (_15 = item.indirizzoConsegna) === null || _15 === void 0 ? void 0 : _15.inCaricoA,
                        extendedAddress: (_16 = item.indirizzoConsegna) === null || _16 === void 0 ? void 0 : _16.indirizzoEsteso,
                        postalCode: (_17 = item.indirizzoConsegna) === null || _17 === void 0 ? void 0 : _17.codicePostale,
                        town: (_18 = item.indirizzoConsegna) === null || _18 === void 0 ? void 0 : _18.citta,
                        province: (_19 = item.indirizzoConsegna) === null || _19 === void 0 ? void 0 : _19.provincia,
                        country: (_20 = item.indirizzoConsegna) === null || _20 === void 0 ? void 0 : _20.paese,
                    },
                    contactUsers: (_21 = item.contattiUtenti) === null || _21 === void 0 ? void 0 : _21.map((item) => {
                        const contatto = {
                            contactName: item.nomeContatto,
                            contactPhone: item.telefonoContatto,
                        };
                        return contatto;
                    }),
                    feesDetail: {
                        annualFee: (_22 = item.dettaglioTasse) === null || _22 === void 0 ? void 0 : _22.tassaAnnuale,
                        periodFee: (_23 = item.dettaglioTasse) === null || _23 === void 0 ? void 0 : _23.tassaPeriodica,
                        signPeriodFee: (_24 = item.dettaglioTasse) === null || _24 === void 0 ? void 0 : _24.tassaPeriodicaSottoscritta,
                        paymentFrequency: (_25 = item.dettaglioTasse) === null || _25 === void 0 ? void 0 : _25.frequenzaPagamento,
                    },
                    voucherMovementsDetail: {
                        matchKey: (_26 = item.dettaglioMovimentiVoucher) === null || _26 === void 0 ? void 0 : _26.chiaveCorrispondenza,
                        responseKey: (_27 = item.dettaglioMovimentiVoucher) === null || _27 === void 0 ? void 0 : _27.chiaveRisposta,
                        movementCode: (_28 = item.dettaglioMovimentiVoucher) === null || _28 === void 0 ? void 0 : _28.codiceMovimento,
                        idCode: (_29 = item.dettaglioMovimentiVoucher) === null || _29 === void 0 ? void 0 : _29.codiceId,
                    },
                    requestResponseDetail: {
                        requestValidity: (_30 = item.dettaglioRequestResponse) === null || _30 === void 0 ? void 0 : _30.validitaRequest,
                    },
                });
            });
            telematicsUI = {
                auto: {
                    operationResult: {
                        code: null,
                        message: null,
                        type: 0,
                    },
                    contracts: contrattiAuto,
                },
                buildings: {
                    operationResult: {
                        code: null,
                        message: null,
                        type: 0,
                    },
                    contracts: contrattiImmobili,
                },
                pets: {
                    operationResult: {
                        code: null,
                        message: null,
                        type: 0,
                    },
                    contracts: [],
                },
            };
        }
        const userInfo = {
            username: usernameUI,
            partyId: partyIdUI,
            registry: registryUI,
            customer: customerUI,
            policies: policiesUI,
            allTelematicContracts: telematicsUI
        };
        return JSON.stringify(userInfo);
    }
    getUserPersonType(personType) {
        switch (personType) {
            case "PG":
                return USER_PERSON_TYPE.PERSONA_GIURIDICA;
            case "PF":
                return USER_PERSON_TYPE.PERSONA_FISICA;
            default:
                return USER_PERSON_TYPE.PERSONA_FISICA_O_GIURIDICA;
        }
    }
}
exports.UserService = UserService;
